import Typography from "@material-ui/core/Typography";
import React, {Fragment} from "react";
import {makeStyles} from "@material-ui/core/styles";
import dateFormat from "dateformat";
import {getMessage} from "../../util";
import Chip from "@material-ui/core/Chip";
import {Card, CardContent} from "@material-ui/core";
import config from "../../config.json";

const useStyles = makeStyles(theme => ({
        chip: {
            marginLeft: theme.spacing(2)
        },
        paragraph: {
            margin: theme.spacing(2)
        },
        number: {
            fontFamily: "Montserrat",
            "font-size":"1.3rem"
        }
    }
));


const QueueItem = (props) => {
    const classes = useStyles();

    return (
        <Fragment>
            { props.myTurn  ? (
                <Card variant="outlined" style={{textAlign: "center", backgroundColor: "antiquewhite"}}>
                    <CardContent>
                        <Fragment>
                            <Typography variant="h3" className={classes.number}>
                                {props.number}
                            </Typography>
                        </Fragment>
                    </CardContent>
                </Card>
            ) : (
                <Card variant="outlined" style={{textAlign: "center"}}>
                    <CardContent>
                        <Fragment>
                            <Typography variant="h3" className={classes.number}>
                                {props.number}
                            </Typography>
                        </Fragment>
                    </CardContent>
                </Card>
            )}
        </Fragment>
    )
}

export default QueueItem;